import moment from "moment";
import { isBoolean } from "lodash";
export default {
  computed: {
    allowOverbooking() {
      return isBoolean(this.attraction.allow_overbooking)
        ? this.attraction.allow_overbooking
        : false;
    },

  },
  methods: {
    past(time) {
      if (_.isInteger(this.attraction.cutoff_minutes)) {
        return moment(time).isBefore(moment().subtract(this.attraction.cutoff_minutes, "minutes"));
      }
      return moment(time).isBefore(moment());
    },
    findAttraction(id){
      return this.attractions.find(a => a.id === id)
    },
    walkInOnly(id){
      const attraction = this.findAttraction(id);
      const ranges = attraction?.walkin_only_dates ?? [];
      if (!ranges.length) return false;
      const today = moment();
      return ranges.some(range =>
          today.isBetween(moment(range.start), moment(range.end), 'day', '[]')
      );
    },
    oneDate(id){
      return this.findAttraction(id)?.one_date ?? null;
    },
    oneDateOnly(id){
      return this.oneDate(id)?.active ?? false
    }
  },
};
